import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Routes from './Routes';

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route {...rest} render={props => (
    <Layout>
      <Component {...props} />
    </Layout>
  )} />
);

const Router = () => {
  return (
    <BrowserRouter>
      <Switch>
        {
          Routes.map((route) => {
            return (
              <AppRoute
                exact
                key={route.path}
                path={route.path}
                component={route.component}
                layout={route.layout}
              />
            );
          })
        }
      </Switch>
    </BrowserRouter>
  );
}

export default Router;



// WEBPACK FOOTER //
// ./src/Router.js